import { gql } from "graphql-tag"

import store from "./store"

const storeLink = gql`
  ${store}

  fragment StoreLink on StoreLink {
    createdAt
    currencyCode
    currencySymbol
    id
    isInStock
    isPreOrder
    isPublished
    priceAmount
    priceFormatted
    publishedAt
    store {
      ...Store
    }
    updatedAt
    url
  }
`

export default storeLink
